import warn from './warn';
export default ((componentName, oldProp, newProp) => {
  warn("".concat(componentName, ": ").concat(oldProp, " is deprecated and will be removed, use ").concat(newProp, " instead"), true);
});
//# sourceMappingURL=deprecate.js.map